import React from 'react';
import {mostraQuota} from '../../utils/formato';
import { chiaveSelezione } from '../../services/profiloDiGioco';
import i18next from 'i18next';

/**
 * Una partita dentro la schedina, con gli esiti scelti su di lei.
 *
 * DUE FORME, e la differenza non e' estetica.
 *
 * Un esito solo -- il caso normale -- sta su UNA RIGA: nome della partita a
 * sinistra, mercato e segno accanto, quota a destra. Su un telefono, con otto
 * selezioni, tre righe a testa diventano uno scorrimento senza fine.
 *
 * Piu' esiti sulla stessa partita restano IMPILATI sotto il nome, perche' e'
 * da li' che nascono le colonne dell'integrale: due esiti dello stesso evento
 * non stanno mai nella stessa colonna, e vederli uno sotto l'altro col loro
 * segno lo dice meglio di qualunque messaggio.
 */
export default function RigaEvento({
  evento,
  fisse,
  mostraFisse,
  onTogli,
  onFissa,
}) {
  const esiti = [];
  (evento.markets || []).forEach((mercato) => {
    (mercato.odds || []).forEach((quota) => {
      esiti.push({ mercato, quota });
    });
  });

  const doppiato = esiti.length > 1;

  /* La fissa sta in TUTTE le colonne: se uno dei due esiti doppiati fosse
     fisso, l'altro non avrebbe nessuna colonna dove esistere. */
  const parti = (mercato, quota) => {
    const chiave = chiaveSelezione(evento, mercato, quota);
    const fissa = fisse && fisse.indexOf(chiave) !== -1;
    return (
      /* Segno, quota e comandi stanno INSIEME in un gruppo: cosi' quando la
         colonna e' stretta vanno a capo tutti e quattro sotto al nome della
         partita, invece di spremerlo fino a farlo andare a capo una lettera
         per riga. Sul sito la schedina e' larga 260 punti, non 380 come il
         banco, e li' si era visto. */
      <span className="lvc-esito-coda">
        <span className="lvc-esito-segno">
          {mercato.marketName}
          {quota.sbv ? ` ${quota.sbv}` : ''}
          {' · '}
          <b>{quota.segno || quota.oddName}</b>
        </span>

        <span className="lvc-esito-quota">
          {mostraQuota(quota.value)}
          {quota.mossa === 'su' && (
            <span className="lvc-esito-mossa lvc-esito-mossa--su">▲</span>
          )}
          {quota.mossa === 'giu' && (
            <span className="lvc-esito-mossa lvc-esito-mossa--giu">▼</span>
          )}
        </span>

        {mostraFisse && (
          <button
            type="button"
            className="lvc-esito-fissa"
            aria-pressed={fissa}
            disabled={doppiato}
            title={doppiato
              ? i18next.t('Non si può fissare un esito quando sulla stessa partita ne hai ')
                + i18next.t('scelti due: non starebbero mai nella stessa colonna')
              : i18next.t('Fissa: presente in tutte le colonne')}
            onClick={() => onFissa && onFissa(chiave)}
          >
            B
          </button>
        )}

        <button
          type="button"
          className="lvc-esito-togli"
          aria-label={`Togli ${quota.segno || quota.oddName}`}
          /* Si passano gli oggetti interi, non gli identificativi: chi
             toglie la selezione deve poter rifare la stessa chiamata con cui
             era stata aggiunta, e quella vuole anche i nomi. */
          onClick={() => onTogli && onTogli(evento, mercato, quota)}
        >
          ✕
        </button>
      </span>
    );
  };

  if (!doppiato) {
    const { mercato, quota } = esiti[0];
    return (
      <div className="lvc-evento">
        <div className="lvc-evento-campionato">{evento.competitionName}</div>
        <div className="lvc-evento-riga">
          <span className="lvc-evento-nome">{evento.matchName}</span>
          {parti(mercato, quota)}
        </div>
      </div>
    );
  }

  return (
    <div className="lvc-evento">
      <div className="lvc-evento-campionato">{evento.competitionName}</div>
      <div className="lvc-evento-nome lvc-evento-nome--sopra">
        {evento.matchName}
        <span className="lvc-evento-nota">{esiti.length}{' '}{i18next.t('combinazioni')}</span>
      </div>
      {esiti.map(({ mercato, quota }) => (
        <div
          className="lvc-evento-riga lvc-evento-riga--rientro"
          key={chiaveSelezione(evento, mercato, quota)}
        >
          {parti(mercato, quota)}
        </div>
      ))}
    </div>
  );
}
